import { render, staticRenderFns } from "./Articleclass.vue?vue&type=template&id=0bc16d13&scoped=true"
import script from "./Articleclass.vue?vue&type=script&lang=js"
export * from "./Articleclass.vue?vue&type=script&lang=js"
import style0 from "./Articleclass.vue?vue&type=style&index=0&id=0bc16d13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc16d13",
  null
  
)

export default component.exports